export function formatPhoneNumber(value) {
  if (!value) return ''

  const refinedValue = value.replace(/[^\d]/g, '')

  if (refinedValue.length < 4) return refinedValue

  if (refinedValue.length < 7) return `${refinedValue.slice(0, 3)}-${refinedValue.slice(3)}`

  return `${refinedValue.slice(0, 3)}-${refinedValue.slice(3, 6)}-${refinedValue.slice(6, 10)}`
}
